import { render, staticRenderFns } from "./GroupSelectedInformer.vue?vue&type=template&id=73063a78&scoped=true&"
import script from "./GroupSelectedInformer.vue?vue&type=script&lang=ts&"
export * from "./GroupSelectedInformer.vue?vue&type=script&lang=ts&"
import style0 from "./GroupSelectedInformer.vue?vue&type=style&index=0&id=73063a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73063a78",
  null
  
)

export default component.exports